import AjaxService, { createRequestUrl } from '../services/ajax-service';
import { getCurrentTeamUrl } from '../services/store-service';

import { syncGetRequest } from '../utils';

const enhanceShortUrl = url => {
    const enhancedUrl = url.replace('niftypm.com', 'nifty.pm').replace(/(.+\/)/g, `$1l/`);
    return enhancedUrl + (enhancedUrl[enhancedUrl.length - 1].match(/^[\d\w]$/i) ? '' : '#');
}

export const shortenUrlAsync = url => {
    return AjaxService({
        method: 'get',
        url: `api/shorten`,
        params: {
            url,
            team_url: getCurrentTeamUrl()
        }
    })
    .then(response => enhanceShortUrl(response.data.link));
}

export const unshortenUrlAsync = token => {
    return AjaxService({
        method: 'get',
        url: `api/unshorten/${token}`
    })
    .then(response => response.data.url);
}

export const shortenUrl = (url, callback, error) => {
    syncGetRequest({
        url: createRequestUrl(`api/shorten`),
        paramsString: `url=${url}&team_url=${getCurrentTeamUrl()}`,
        callback: response => {
            callback(enhanceShortUrl(JSON.parse(response).link));
        },
        error
    });
}

export const unshortenUrl = (token, callback) => {
    syncGetRequest({
        url: createRequestUrl(`api/unshorten/${token}`),
        callback: response => {
            callback(JSON.parse(response).url);
        }
    });
}

export const getLocations = input => {
    return AjaxService({
        method: 'get',
        url: `api/locations`,
        params: { input }
    })
    .then(response => response.data);
}

export const typingStart = ({ association, association_id }) => {
    return AjaxService({
        method: 'post',
        url: `client-events/typing_start`,
        data: { association, association_id }
    })
    .then(response => response.data);
}

export const typingEnd = ({ association, association_id }) => {
    return AjaxService({
        method: 'post',
        url: `client-events/typing_end`,
        data: { association, association_id }
    })
    .then(response => response.data);
}

export const getStatus = () => {
    return AjaxService({
        method: 'get',
        url: `status`
    })
    .then(response => response.data);
}

export const batch = (requests, sync) => {
    return AjaxService({
        method: 'post',
        url: `batch${sync ? '/sync' : ''}`,
        data: { requests }
    })
    .then(response => response.data);
}

export const log = ({ log, meta }) => {
    return AjaxService({
        method: 'post',
        url: `log`,
        data: { log, meta }
    })
    .then(response => response.data);
}

export const permissionCheck = ({ type, id, token }) => {
    return AjaxService({
        method: 'get',
        url: 'permission/check',
        params: {
            type,
            resource_id: id
        }
    }, false, token)
    .then(response => response.data);
}
